/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ home: NonNullable<unknown>, away: NonNullable<unknown> }} Email_Game_Start_SubjectInputs */

const th_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} พบ ${i?.away} เริ่มแล้ว`)
};

const en_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} vs ${i?.away} has started`)
};

const ja_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 対 ${i?.away} が始まりました`)
};

const zh_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 对阵 ${i?.away} 已开始`)
};

const es_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contra ${i?.away} ha comenzado`)
};

const pt_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} x ${i?.away} começou`)
};

const id_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} lawan ${i?.away} sudah dimulai`)
};

const fr_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contre ${i?.away} a commencé`)
};

const tl_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nagsimula na ang ${i?.home} laban sa ${i?.away}`)
};

const vi_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} gặp ${i?.away} đã bắt đầu`)
};

const ko_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 대 ${i?.away} 경기가 시작되었습니다`)
};

const de_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} gegen ${i?.away} hat begonnen`)
};

const ru_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} — ${i?.away}: матч начался`)
};

const tr_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} – ${i?.away} maçı başladı`)
};

const it_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contro ${i?.away} è iniziata`)
};

const pl_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mecz ${i?.home} – ${i?.away} się rozpoczął`)
};

const uk_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} проти ${i?.away} — матч почався`)
};

const hi_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} बनाम ${i?.away} शुरू हो गया`)
};

const ar_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بدأت مباراة ${i?.home} ضد ${i?.away}`)
};

const ms_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} lawan ${i?.away} sudah bermula`)
};

const bn_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} বনাম ${i?.away} শুরু হয়েছে`)
};

const zh_tw2_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 對 ${i?.away} 已開打`)
};

const zh_hk2_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 對 ${i?.away} 已開打`)
};

const ur_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} بمقابلہ ${i?.away} شروع ہو گیا`)
};

const fa_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} مقابل ${i?.away} آغاز شد`)
};

const sw_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} dhidi ya ${i?.away} umeanza`)
};

const nl_email_game_start_subject = /** @type {(inputs: Email_Game_Start_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} tegen ${i?.away} is begonnen`)
};

/**
* | output |
* | --- |
* | "{home} vs {away} has started" |
*
* @param {Email_Game_Start_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_game_start_subject = /** @type {((inputs: Email_Game_Start_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Game_Start_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_game_start_subject(inputs)
	if (locale === "ja") return ja_email_game_start_subject(inputs)
	if (locale === "zh") return zh_email_game_start_subject(inputs)
	if (locale === "es") return es_email_game_start_subject(inputs)
	if (locale === "pt") return pt_email_game_start_subject(inputs)
	if (locale === "id") return id_email_game_start_subject(inputs)
	if (locale === "fr") return fr_email_game_start_subject(inputs)
	if (locale === "tl") return tl_email_game_start_subject(inputs)
	if (locale === "vi") return vi_email_game_start_subject(inputs)
	if (locale === "ko") return ko_email_game_start_subject(inputs)
	if (locale === "de") return de_email_game_start_subject(inputs)
	if (locale === "ru") return ru_email_game_start_subject(inputs)
	if (locale === "tr") return tr_email_game_start_subject(inputs)
	if (locale === "it") return it_email_game_start_subject(inputs)
	if (locale === "pl") return pl_email_game_start_subject(inputs)
	if (locale === "uk") return uk_email_game_start_subject(inputs)
	if (locale === "hi") return hi_email_game_start_subject(inputs)
	if (locale === "ar") return ar_email_game_start_subject(inputs)
	if (locale === "ms") return ms_email_game_start_subject(inputs)
	if (locale === "bn") return bn_email_game_start_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_game_start_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_game_start_subject(inputs)
	if (locale === "ur") return ur_email_game_start_subject(inputs)
	if (locale === "fa") return fa_email_game_start_subject(inputs)
	if (locale === "sw") return sw_email_game_start_subject(inputs)
	if (locale === "nl") return nl_email_game_start_subject(inputs)
	return en_email_game_start_subject(inputs)
});